<template>
  <div class="app-main-content">
    <div
      type="primary"
      style="display: flex;"
    >
      <el-form
        label-width="60px"
        style="display:flex;"
      >
        <el-form-item :label="$t('Pricing.FlightNo')">
          <el-input
            v-model="proxy.flightNo"
          />
        </el-form-item>

        <el-form-item :label="$t('Pricing.POL')">
          <cargo-advance-select
            filterable
            :placeholder="$t('Pricing.POLPrompt')"
            :select-type="selectTypeNames.basic_data_Airport"
            :custom-label="(item)=>`[${item.code}]${item.englishName}`"
            :filter-tag-names="['code','englishName']"
            :show-custom-label-in-option="true"
            :default-value="proxy.pol"
            style="width:190px;display: inline-block;"
            @parentCallBack="p=>{proxy.pol=p.value}"
          />
        </el-form-item>

        <el-form-item :label="$t('Pricing.POD')">
          <cargo-advance-select
            filterable
            :placeholder="$t('Pricing.PODPrompt')"
            :select-type="selectTypeNames.basic_data_Airport"
            :custom-label="(item)=>`[${item.code}]${item.englishName}`"
            :filter-tag-names="['code','englishName']"
            :show-custom-label-in-option="true"
            :default-value="proxy.pod"
            style="width:190px;display: inline-block;"
            @parentCallBack="p=>{proxy.pod=p.value}"
          />
        </el-form-item>
      </el-form>
      <div style="margin-left:20px;">
        <el-button no="query" style="margin-left: 10px" type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
        <el-button no="reset" type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <el-button no="onEdit" type="primary" :disabled="!this.selectRow" @click="onEdit()">{{ $t('Pricing.Edit') }}</el-button>
        <el-button no="onDelete" type="danger" @click="onDelete()">{{ $t('Pricing.Delete') }}</el-button>
        <el-button no="onAdd" type="primary" @click="onAdd()">{{ $t('Pricing.Add') }}</el-button>
        <el-button no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
        <el-upload
          no="uploadExcelSuccess"
          :action="URL.price.airFlightInfo.register"
          :headers="{sessionId}"
          :show-file-list="false"
          accept=".xls, .xlsx"
          :on-success="uploadExcelSuccess"
          :data="{currentOfficeId:$store.getters.currentOfficeId}"
          style="display: inline-block; margin-left: 5px"
        >
          <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
        </el-upload>
      </div>
    </div>
    <div class="grid-view">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="2023041201"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :export-file-name="priceUtil.getFileName('SailingSchedule')"
            :row-data="rowData"
          />
        </div>
      </div>
    </div>
    <add-air-flight-information
      :visible="shippingScheduleFormDialog.visible"
      :ss="shippingScheduleFormDialog.ss"
      :is-new="shippingScheduleFormDialog.isNew"
      @close="onShippingScheduleFormDialogClose"
      @reload="toQuery"
    />
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { queryAirFlightInfo, deleteAirFlightInfo } from '@/api/price/airFlightInfo'
import DateUtils from '@/utils/dateUtils'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import ShippingScheduleDataGrid from '@/views/cargo/v0/Price/components/grid/shippingScheduleDataGrid'
import addAirFlightInformation from '@/views/cargo/v0/Price/AirFlightInformationManagement/components/addAirFlightInformation'

export default {
  name: 'ShippingSchedule',
  components: {
    addAirFlightInformation,
    ShippingScheduleDataGrid,
    cargoAdvanceSelect
  },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      priceUtil: PriceUtils,
      fullscreenLoading: null,
      proxy: {
        pol: '',
        pod: '',
        flightNo: ''
      },
      filter: {
        pol: '',
        pod: '',
        flightNo: '',
        carrier: '',
        createdBy: 0,
        branch: 0,
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: ''
      },
      rowData: [],
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          if (rows.length > 0) {
            this.selectRow = rows[0]
            console.log('this.selectRow====', this.selectRow)
          } else {
            this.selectRow = null
          }
        }
      },
      columnDefs: [
        {
          headerName: ' ',
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.FlightNo'), field: 'flightNo', colId: 'flightNo' },
        {
          headerName: this.$t('Pricing.POL'),
          field: 'pol',
          colId: 'pol',
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('Pricing.POD'),
          field: 'pod',
          colId: 'pod',
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        { headerName: this.$t('Pricing.ClosingTime'), field: 'closingTime', colId: 'closingTime' },
        { headerName: this.$t('Pricing.DepartureTime'), field: 'departureTime', colId: 'departureTime' },
        { headerName: this.$t('Pricing.AirDay'), field: 'days', colId: 'days' },
        { headerName: this.$t('Pricing.ArrivalTime'), field: 'arrivalTime', colId: 'arrivalTime' },
        { headerName: this.$t('Pricing.Aircraft'), field: 'aircraft', colId: 'aircraft' },
        { headerName: this.$t('Pricing.SizeLimit'), field: 'sizeLimit', colId: 'sizeLimit' },
        { headerName: this.$t('Pricing.SingletonWeightLimit'), field: 'singletonWeightLimit', colId: 'singletonWeightLimit' },
        { headerName: this.$t('Pricing.ChemicalPkggReq'), field: 'chemicalPkggReq', colId: 'chemicalPkggReq' },
        { headerName: this.$t('Pricing.LithiumBatteryReq'), field: 'lithiumBatteryReq', colId: 'lithiumBatteryReq' }
      ],
      shippingScheduleFormDialog: {
        visible: false,
        ss: {
          days: '+0'
        },
        isNew: false
      },
      selectRow: null // 已发布的单击选择行
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    }
  },
  methods: {
    onShippingScheduleFormDialogClose() {
      this.shippingScheduleFormDialog.visible = false
      this.shippingScheduleFormDialog.data = {}
    },
    // 查询
    toQuery() {
      this.fullscreenLoading = getLoading()
      queryAirFlightInfo(this.proxy).then((res) => {
        this.loadingEnd()
        this.rowData = res.data
        if (this.rowData && this.rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
          return
        }
        if (this.rowData.length > PriceConstant.MAX_QUERY_COUNT) {
          this.rowData.pop() // 删除第PriceConstant.MAX_QUERY_COUNT+1条
          this.$message.warning(this.$t('Pricing.MaxQueryCount'))
        }
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    resetSearch() {
      this.proxy = {
        pol: '',
        pod: '',
        flightNo: ''
      }
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.selectRow = null
      this.fullscreenLoading.close()
    },
    onRowDoubleClicked(e) {
      const data = e.data
      this.selectRow = data
      this.edit(data)
    },
    onEdit() {
      console.log('this.selectRow=============1', this.selectRow)
      this.edit(this.selectRow)
    },
    onDelete() {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      const message = selectedRows.length > 1 ? this.$t('Pricing.IsDeleteRecords') : this.$t('Pricing.IsDeleteRecord')
      this.$confirm(message, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.fullscreenLoading = getLoading()
        deleteAirFlightInfo(uuids).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.gridOptions.api.updateRowData({ remove: selectedRows })
        }).finally(() => {
          this.loadingEnd()
        })
      })
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    edit(selectRow) {
      if (!selectRow) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.shippingScheduleFormDialog.visible = true
      this.shippingScheduleFormDialog.isNew = false
      this.shippingScheduleFormDialog.ss = selectRow
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    onAdd() {
      this.shippingScheduleFormDialog.visible = true
      this.shippingScheduleFormDialog.isNew = true
      this.shippingScheduleFormDialog.ss = {
        days: '+0',
        aircraft: '',
        sizeLimit: '',
        singletonWeightLimit: '',
        chemicalPkggReq: '',
        lithiumBatteryReq: ''
      }
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('Air_Flight_Info_sample.xls', 'price')
    },
    selectRowChange(data) {
      this.selectRow = data
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        if (result === '') {
          this.$message.error(this.$t('Pricing.NoRecordUpload'))
          return
        }
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          const tmp = result.split(':')
          msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
          msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        }
        return false
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      const msg = {
        dangerouslyUseHTMLString: true,
        message: failResult.replace(/\n\t/g, '<br/>'),
        type: 'error',
        duration: 5000
      }
      this.$message.error(msg)
    }
  }
}
</script>

<style scoped>

</style>
